
// Angular
import { NgModule } from '@angular/core';

import { TableServicesService } from './table-services.service';
import { SectorAirServicesService } from '../sector-air-services/sector-air-services.service';
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";


@NgModule({
    imports:[
        TravellerDataTranslationModule
    ],
    providers: [
        SectorAirServicesService,
        TableServicesService,
    ],
})
export class TableServicesServiceModule {}